import { State } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelsModel from "../models/BURReelsModel";
import BURSpinModel from "../models/BURSpinModel";

export default class BURTransformSymbolsState extends State {
    public async enter() {
        super.enter();

        const stickyWilds = new Set(
            BURFeatureModel.random_wilds_positions.map((w) => `${w.x},${w.y}`)
        );

        // Transform all symbols except the wilds injected by the Storm of the buffalo feature
        await Promise.all(
            BURSpinModel.mystery_positions
                .filter((pos) => !stickyWilds.has(`${pos.x},${pos.y}`))
                .map(async (pos) => {
                    await BURReelsModel.reels.transformMysterySymbol(pos);
                })
        );

        // If any mystery symbols have transformed into energy coins, play the energy charge feature
        if (BURFeatureModel.mystery_energy_coins.length > 0) {
            await BURReelsModel.reels.playEnergyCharge(true);
            // Reset the energy coins from mystery flips
            BURFeatureModel.setMysteryEnergyCoins([]);
        }

        this.exit();
    }
}
